"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var camelToHyphen_1 = require("./camelToHyphen");

var QUERY_COMBINATOR = ' and ';

function queryObjectToString(query) {
  if (typeof query === 'string') {
    return query;
  }

  return Object.entries(query).map(function (_a) {
    var feature = _a[0],
        value = _a[1];
    var convertedFeature = camelToHyphen_1.default(feature);
    var convertedValue = value;

    if (typeof convertedValue === 'boolean') {
      return convertedValue ? convertedFeature : "not " + convertedFeature;
    }

    if (typeof convertedValue === 'number' && /[height|width]$/.test(convertedFeature)) {
      convertedValue = convertedValue + "px";
    }

    return "(" + convertedFeature + ": " + convertedValue + ")";
  }).join(QUERY_COMBINATOR);
}

exports.default = queryObjectToString;